import { defineMessages } from "react-intl";

export const messages = defineMessages({
  selectAll: {
    id: "app.smartSelector.selectAll",
    description: "Select All",
    defaultMessage: "Select All",
  },
  deselectAll: {
    id: "app.smartSelector.deselectAll",
    description: "Deselect All",
    defaultMessage: "Deselect All",
  },
});
